/**
 * Light browser Notification helpers for chat pings when the tab is hidden.
 * No-ops when unsupported or permission denied.
 */

export function notificationPermission() {
  if (typeof window === 'undefined' || typeof Notification === 'undefined') {
    return 'unsupported';
  }
  return Notification.permission;
}

/** Request permission once; safe to call from Messages mount. */
export async function ensureNotificationPermission() {
  if (typeof window === 'undefined' || typeof Notification === 'undefined') {
    return 'unsupported';
  }
  if (Notification.permission !== 'default') {
    return Notification.permission;
  }
  try {
    return await Notification.requestPermission();
  } catch {
    return 'denied';
  }
}

/**
 * Show a system notification only when the document is hidden and permission is granted.
 */
export function showBrowserNotification(title, options = {}) {
  if (typeof window === 'undefined' || typeof Notification === 'undefined') {
    return null;
  }
  if (Notification.permission !== 'granted') return null;
  if (typeof document !== 'undefined' && document.visibilityState === 'visible') {
    return null;
  }
  try {
    const n = new Notification(title, {
      icon: '/favicon.ico',
      badge: '/favicon.ico',
      ...options,
    });
    if (options.onClick) {
      n.onclick = (e) => {
        e.preventDefault();
        window.focus();
        options.onClick();
        n.close();
      };
    }
    return n;
  } catch {
    return null;
  }
}
